export const apiUrls = {
  gameUserGetUsersPaginateUrl: 'game/users/get-users-paginate',
  gameUserGetExportUrl: 'game/users/get-users-export',
  gameUserGetUserUrl: 'game/users/get-user',
  gameUserGetUsersPaginateByCertificationStateUrl: 'game/users/get-users-paginate-by-certification-state',
  gameUserGetUserCertificationIdentityFileUrl: 'game/users/get-user-certification-identity-file',
  gameUserEditUserUrl: 'game/users/edit-user',
  gameUserUpdateUserCurrencyUrl: 'game/users/update-user-currency',
  gameUserChangeUserBanStateUrl: 'game/users/change-user-ban-state',
  gameUserChangeUserMobilePhoneValidStateUrl: 'game/users/change-user-mobile-phone-valid-state',
  gameUserResetUserDeviceIdStateUrl: 'game/users/reset-user-device-id',
  gameUserResetAllUsersDeviceIdStateUrl: 'game/users/reset-all-users-device-id',
  gameUserEditUserCertificationUrl: 'game/users/edit-user-certification',
  gameUserSendNotificationPushUrl: 'game/users/send-user-notification-push',

  gameUserGamesHistoryGetUsersPaginateUrl: 'game/users-games-history/get-user-games-history-paginate',

  gameUserTransactionsEditUserTransactionStateUrl: 'game/users-transactions/edit-user-transaction-state',
  gameUserTransactionsGetUserTransactionsPaginateUrl: 'game/users-transactions/get-user-transactions-paginate',
  gameUserTransactionsGetUsersTransactionsPaginateUrl: 'game/users-transactions/get-users-transactions-paginate',

  gameConfigurationEditConfigurationUrl: 'game/configuration/editConfiguration',
  gameConfigurationGetConfigurationUrl: 'game/configuration/getConfiguration',

  gameTournamentEditTournamentUrl: 'game/tournaments/edit-tournament',
  gameTournamentDeleteTournamentUrl: 'game/tournaments/delete-tournament',
  gameTournamentChangeTournamentDateClosedStateUrl: 'game/tournaments/change-tournament-date-closed-state',
  gameTournamentGetTournamentUrl: 'game/tournaments/get-tournament',
  gameTournamentGetTournamentsUrl: 'game/tournaments/get-tournaments',
  gameTournamentGetTournamentsPaginateUrl: 'game/tournaments/get-tournaments-paginate',
  gameTournamentEditTournamentDateUrl: 'game/tournaments/edit-tournament-date',
  gameTournamentDeleteTournamentDateUrl: 'game/tournaments/delete-tournament-date',
  gameTournamentGetTournamentDateUrl: 'game/tournaments/get-tournament-date',
  gameTournamentGetTournamentsDatespaginateUrl: 'game/tournaments/get-tournaments-dates-paginate',
  gameTournamentChangeUserBanStateUrl: 'game/tournaments/change-tournament-user-ban-state',
  gameTournamentGetTournamentsUserspaginateUrl: 'game/tournaments/get-tournaments-users-paginate',
  gameTournamentGetTournamentsUsersPaginateByUserIdUrl: 'game/tournaments/get-tournaments-users-paginate-by-user-id',
  gameTournamentGetTournamentsUsersExportUrl: 'game/tournaments/get-tournaments-users-export',

  gameStatisticsGetStatisticsUrl: 'game/statistics/get-statistics',
  gameStatisticsGetStatisticsDaysUrl: 'game/statistics/get-statistics-days',
  
  adminUsersLoginUrl: 'admin/user/login',
  adminUsersGetUsersUrl: 'admin/user/getUsers',
  adminUsersDeleteUrl: 'admin/user/deleteUser',
  adminUsersEditUrl: 'admin/user/editUser',
  adminUsersEditPasswordUrl: 'admin/user/editUserPassword',
  adminUsersAddUrl: 'admin/user/addUser',

  applicationsGetApplicationsUrl: 'applications/getApplications',
  applicationsAddApplicationUrl: 'applications/addApplication',
  applicationsEditApplicationUrl: 'applications/editApplication',
  applicationsDeleteApplicationUrl: 'applications/deleteApplication',

  usersGetUsersUrl: 'users/getUsers',
  usersGetUserUrl: 'users/getUser',
  usersAddCurrencyUrl: 'users/addCurrency',
  usersEditUserNicknameUrl: 'users/editUserNickname',
  usersAddLevelExperienceUrl: 'users/addLevelExperience',
  usersAddBoosterUrl: 'users/addBooster',
  usersGetUserTransactionsUrl: 'users/getUserTransactions',
  usersGetUsersTransactionsStatisticsUrl: 'users/getUsersTransactionsStatistics',
  usersGetUserMatchsUrl: 'users/getUserMatchs',
  usersGetUserMatchUrl: 'users/getUserMatch',
  usersGetUserLogsUrl: 'users/getUserLogs',
  usersGetUserSessionsUrl: 'users/getUserSessions',
  usersGetUserLeaguesUrl: 'users/getUserLeagues',
  usersGetUserTournamentsUrl: 'users/getUserTournaments',
  usersGetUserReportsUrl: 'users/getUserReports',
  usersGetUserCollectionsUrl: 'users/getUserCollections',
  usersGetUserCollectionAlbumsUrl: 'users/getUserCollectionAlbums',
  usersGetUserCollectionAlbumCardsUrl: 'users/getUserCollectionAlbumCards',
  usersAddUserCollectionAlbumCardUrl: 'users/addUserCollectionAlbumCard',
  usersRemoveUserCollectionAlbumCardUrl: 'users/removeUserCollectionAlbumCard',
  usersDeleteUserUrl: 'users/deleteUser',
  usersRestoreUserUrl: 'users/restoreUser',
  usersChangeUserBanStateUrl: 'users/changeUserBanState',

  languagesGetLanguagesUrl: 'languages/getLanguages',
  languagesAddLanguageUrl: 'languages/addLanguage',
  languagesEditLanguageUrl: 'languages/editLanguage',
  languagesDeleteLanguageUrl: 'languages/deleteLanguage',
  languagesChangeLanguageActiveStateUrl: 'languages/changeLanguageActiveState',

  shopGetItemsUrl: 'shop/getItems',
  shopAddItemUrl: 'shop/addItem',
  shopEditItemUrl: 'shop/editItem',
  shopDeleteItemUrl: 'shop/deleteItem',
  shopGetPacksUrl: 'shop/getPacks',
  shopAddPackUrl: 'shop/addPack',
  shopEditPackUrl: 'shop/editPack',
  shopDeletePackUrl: 'shop/deletePack',
  shopDeleteNextPacksUrl: 'shop/deleteNextPacks',
  shopAddPacksFromFileUrl: 'shop/addPacksFromFile',
  shopGetShopStatisticsUrl: 'shop/getShopStatistics',

  newsGetNewsUrl: 'news/getNews',
  newsGetNewsUserUrl: 'news/getNewsUser',
  newsAddNewsUserUrl: 'news/addNewsUser',
  newsEditNewsUserUrl: 'news/editNewsUser',
  newsAddNewsUrl: 'news/addNews',
  newsEditNewsUrl: 'news/editNews',
  newsDeleteNewsUrl: 'news/deleteNews',
  newsChangeActiveStateUrl: 'news/changeNewsActiveState',
  newsAddNewsRewardUrl: 'news/addNewsReward',
  newsEditNewsRewardUrl: 'news/editNewsReward',
  newsDeleteNewsRewardUrl: 'news/deleteNewsReward',
  newsGetNewsPredefinedUrl: 'news/getNewsPredefined',
  newsAddNewsPredefinedUrl: 'news/addNewsPredefined',
  newsEditNewsPredefinedUrl: 'news/editNewsPredefined',
  newsDeleteNewsPredefinedUrl: 'news/deleteNewsPredefined',
  newsEditNewsPredefinedTranslationUrl: 'news/editNewsPredefinedTranslation',
  newsDeleteNewsPredefinedTranslationUrl: 'news/deleteNewsPredefinedTranslation',

  versionsGetVersionsUrl: 'versions/getVersions',
  versionsAddVersionUrl: 'versions/addVersion',
  versionsEditVersionUrl: 'versions/editVersion',
  versionsDeleteVersionUrl: 'versions/deleteVersion',

  tournamentsGetTournamentsUrl: 'tournaments/getTournaments',
  tournamentsGetTournamentUsersUrl: 'tournaments/getTournamentUsers',
  tournamentsAddTournamentUrl: 'tournaments/addTournament',
  tournamentsEditTournamentUrl: 'tournaments/editTournament',
  tournamentsDeleteTournamentUrl: 'tournaments/deleteTournament',
  tournamentsAddTournamentsFromFileUrl: 'tournaments/addTournamentsFromFile',

  missionsGetMissionsUrl: 'missions/getMissions',
  missionsGetMissionUsersUrl: 'missions/getMissionUsers',
  missionsAddMissionUrl: 'missions/addMission',
  missionsEditMissionUrl: 'missions/editMission',
  missionsDeleteMissionUrl: 'missions/deleteMission',
  missionsGetMissionsRewardsUrl: 'missions/getMissionsRewards',
  missionsAddMissionRewardUrl: 'missions/addMissionReward',
  missionsEditMissionRewardUrl: 'missions/editMissionReward',
  missionsDeleteMissionRewardUrl: 'missions/deleteMissionReward',
  missionsAddMissionsFromFileUrl: 'missions/addMissionsFromFile',
  missionsAddMissionsRewardsFromFileUrl: 'missions/addMissionsRewardsFromFile',

  leaguesGetLeaguesUrl: 'leagues/getLeagues',
  leaguesAddLeagueUrl: 'leagues/addLeague',
  leaguesEditLeagueUrl: 'leagues/editLeague',
  leaguesDeleteLeagueUrl: 'leagues/deleteLeague',
  leaguesGetLeaguesRewardsUrl: 'leagues/getLeaguesRewards',
  leaguesAddLeagueRewardUrl: 'leagues/addLeagueReward',
  leaguesEditLeagueRewardUrl: 'leagues/editLeagueReward',
  leaguesDeleteLeagueRewardUrl: 'leagues/deleteLeagueReward',
  leaguesGetLeaguesDivisionsUrl: 'leagues/getLeaguesDivisions',
  leaguesGetLeagueDivisionUsersUrl: 'leagues/getLeagueDivisionUsers',

  levelsGetLevelsUrl: 'levels/getLevels',
  levelsAddLevelUrl: 'levels/addLevel',
  levelsEditLevelUrl: 'levels/editLevel',
  levelsDeleteLevelUrl: 'levels/deleteLevel',

  matchsGetMatchsTablesUrl: 'matchs/getMatchsTables',
  matchsAddMatchTableUrl: 'matchs/addMatchTable',
  matchsEditMatchTableUrl: 'matchs/editMatchTable',
  matchsDeleteMatchTableUrl: 'matchs/deleteMatchTable',
  matchsGetMatchsCcuUrl: 'matchs/getMatchsCcu',
  matchsGetMatchsCreditBalanceUrl: 'matchs/getMatchsCreditBalance',

  slotGetSlotRewardsUrl: 'slot/getSlotRewards',
  slotGetSlotCreditBalanceUrl: 'slot/getSlotCreditBalance',
  slotAddSlotRewardUrl: 'slot/addSlotReward',
  slotEditSlotRewardUrl: 'slot/editSlotReward',
  slotDeleteSlotRewardUrl: 'slot/deleteSlotReward',
  slotTestSlotUrl: 'slot/testSlot',
  languagesGetLanguageTranslationsMissingKeysUrl: 'languages/getlanguageTranslationsMissingKeys',
  languagesGetLanguageTranslationsUrl: 'languages/getlanguageTranslations',
  languagesAddLanguageTranslationUrl: 'languages/addlanguageTranslation',
  languagesEditLanguageTranslationUrl: 'languages/editlanguageTranslation',
  languagesDeleteLanguageTranslationUrl: 'languages/deletelanguageTranslation',

  configurationsGetConfigurationsUrl: 'configurations/getConfigurations',
  configurationsGetServerConfigurationsUrl: 'configurations/getServerConfigurations',
  configurationsGetClientConfigurationsUrl: 'configurations/getClientConfigurations',
  configurationsEditConfigurationUrl: 'configurations/editConfiguration',
  configurationsDeleteConfigurationUrl: 'configurations/deleteConfiguration',
  configurationsDeleteApplicationConfigurationUrl: 'configurations/deleteApplicationConfiguration',

  bugReportsGetReportsUrl: 'bug_reports/getReports',
  bugReportsGetReportsOpenCountUrl: 'bug_reports/getReportsOpenCount',
  bugReportsChangeReportStateUrl: 'bug_reports/changeReportState',

  collectionsGetAllCollectionsUrl: 'collections/getAllCollections',
  collectionsGetCollectionsUrl: 'collections/getCollections',
  collectionsAddCollectionUrl: 'collections/addCollection',
  collectionsEditCollectionUrl: 'collections/editCollection',
  collectionsDeleteCollectionUrl: 'collections/deleteCollection',
  collectionsGetCollectionAlbumsUrl: 'collections/getCollectionAlbums',
  collectionsAddCollectionAlbumUrl: 'collections/addCollectionAlbum',
  collectionsEditCollectionAlbumUrl: 'collections/editCollectionAlbum',
  collectionsDeleteCollectionAlbumUrl: 'collections/deleteCollectionAlbum',
  collectionsGetCollectionAlbumCardsUrl: 'collections/getCollectionAlbumCards',
  collectionsAddCollectionAlbumCardUrl: 'collections/addCollectionAlbumCard',
  collectionsEditCollectionAlbumCardUrl: 'collections/editCollectionAlbumCard',
  collectionsDeleteCollectionAlbumCardUrl: 'collections/deleteCollectionAlbumCard',
  collectionsGetCollectionsPeriodsUrl: 'collections/getCollectionsPeriods',
  collectionsAddCollectionPeriodUrl: 'collections/addCollectionPeriod',
  collectionsEditCollectionPeriodUrl: 'collections/editCollectionPeriod',
  collectionsDeleteCollectionPeriodUrl: 'collections/deleteCollectionPeriod',
  collectionsGetCollectionsBoostersUrl: 'collections/getCollectionsBoosters',
  collectionsEditCollectionBoosterUrl: 'collections/editCollectionBooster',
  collectionsUploadCollectionImageUrl: 'collections/uploadCollectionImage',
  collectionsUploadCollectionAlbumImageUrl: 'collections/uploadCollectionAlbumImage',
  collectionsUploadCollectionAlbumCardImageUrl: 'collections/uploadCollectionAlbumCardImage',
};
